module.exports = __webpack_public_path__ + "static/media/cart.c675c135.svg";